module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "layui-icon"
  }, [(_vm.icon == 'up') ? [_vm._v("\n    \n  ")] : _vm._e(), _vm._v(" "), (_vm.icon == 'down') ? [_vm._v("\n    \n  ")] : _vm._e(), _vm._v(" "), (_vm.icon == 'delete') ? [_vm._v("\n    \n  ")] : _vm._e(), _vm._v(" "), (_vm.icon == 'right') ? [_vm._v("\n    \n  ")] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59f9185a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmIcon.vue
// module id = 592
// module chunks = 2